import { DamagedPartDescriptionModalProps } from '@/common/components/adjusterReport/damagedPoints/damagedPointsDescriptionModal/DamagedPointsDescriptionModal.type';
import {
  DamagedPartDescriptionQueryParamsType,
  getDamagedPartDescriptionQueryParamsType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/damagedPartDescription/damagedPartDescriptionQuery.type';
import { damagedPartDescriptionFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/damagedPartDescription/damagedPartDescriptionQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getDamagedPartDescriptionQueryOptions = (
  params: DamagedPartDescriptionQueryParamsType &
    DamagedPartDescriptionModalProps & {
      success: (data: getDamagedPartDescriptionQueryParamsType) => void;
    },
) => {
  return queryOptions({
    queryKey: ['DamagedPartDescription', params],
    queryFn: () => damagedPartDescriptionFunction({ ...params, method: 'get' }),
    meta: { onSuccess: (data) => params.success(data) },
  });
};
